<template>
  <div>
    <common-dialog
      ref="dialog"
      width="850px"
      show-save-button
      unit="摘要"
      edit-title
      id-key="AbstractId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      @opened="onOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="摘要描述" prop="Abstract">
              <el-input
                type="textarea"
                :maxlength="60"
                v-model="data.Abstract"
                placeholder="请输入描述"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="单据类型">
              <invoice-select v-model="data.SourceTypeId" :clearable="false" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="序号">
              <el-input
                type="number"
                v-int
                v-model="data.SerialNumber"
                style="width: 100px"
              ></el-input>
              <span class="t-tips">*值越小排得越前</span>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import invoiceSelect from "@/components/basedata/basedoc/billtype/select";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    invoiceSelect,
  },
  data() {
    return {
      data: {
        AbstractId: 0,
        SourceTypeId: null,
        Abstract: "",
        SerialNumber: null,
      },
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/ba/abstract").default,
      // trendData: iForm.Data,
      showList: [],
      rules: {
        TransportNo: [{ required: true, message: "请输入编号" }],
        Abstract: [{ required: true, message: "请输入描述" }],
        SerialNumber: [{ required: true, message: "请输入序号" }],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {
      let modeName = this.urlHash
        ? this.urlHash.split("/").join("")
        : location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });
    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },
    onCreateOpened(data) {
      this.api.getMaxSn().then((res) => {
        this.data.SerialNumber = res;
      });
    },
    onEditOpened(data) {},
    onClosed() {
      this.showList = [];
    },
  },
};
</script>
